import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    SEO_PAGE_TITLE: 'Cálculo de horas | Asistencia | Crehana',
    SEO_PAGE_DESCRIPTION:
      'Visualiza el cálculo de horas extras y horas de atraso de los registros de asistencia.',
    BREADCRUMB_HOME: 'Inicio',
    BREADCRUMB_ATTENDANCE: 'Asistencia',
    BREADCRUMB_HOURS_CALCULATION: 'Cálculo de horas',
    PAGE_TITLE: 'Cálculo de horas',
    PAGE_DESCRIPTION:
      'Visualiza el cálculo de horas extras y horas de atraso de los registros de asistencia de tus colaboradores',
    CTA_DOWNLOAD_REPORT: 'Descargar reporte',
    DOWNLOAD_COMING_SOON: 'Disponible próximamente',
    FILTER_PERIOD_LABEL: 'Periodo:',
    FILTER_DATE_SEPARATOR: 'al',
    FILTER_BUTTON: 'Filtrar',
    CARD_TOTAL_COLLABORATORS: 'Total colaboradores',
    CARD_TOTAL_COLLABORATORS_SUB: 'Con registros en el periodo',
    CARD_OVERTIME_HOURS: 'Horas extras acumuladas',
    CARD_LATE_HOURS: 'Horas de atraso',
    CARD_TEAM_TOTAL: 'Total del equipo',
    TABLE_TITLE: 'Resumen por colaborador',
    SEARCH_PLACEHOLDER: 'Buscar colaborador...',
    COLUMN_COLLABORATOR: 'Colaborador',
    COLUMN_SHIFT: 'Turno asignado',
    COLUMN_WORKED_HOURS: 'Horas trabajadas',
    COLUMN_OVERTIME: 'Horas extras',
    COLUMN_LATE_HOURS: 'Horas de atraso',
    DAILY_BREAKDOWN_TITLE: 'Desglose diario',
    DETAIL_COL_DATE: 'Día',
    DETAIL_COL_PLANNED_HOURS: 'Horas planificadas',
    DETAIL_COL_WORKED_HOURS: 'Horas trabajadas',
    DETAIL_COL_OVERTIME: 'Horas extras',
    DETAIL_COL_LATE_HOURS: 'Horas de atraso',
    DETAIL_ACTION_REVIEW: 'Revisar',
    EMPTY_NO_DATA: 'No hay registros de marcaje en el periodo seleccionado.',
    EMPTY_NO_DATA_DESCRIPTION:
      'Selecciona otro periodo o verifica que los colaboradores tengan registros.',
    FILTER_RANGE_DAYS: '({{count}} días)',

    // table root states messages
    TABLE_STATE_ERROR_TITLE: 'Error al cargar los datos',
    TABLE_STATE_ERROR_SUBTITLE:
      'Ocurrió un error al cargar la información. Por favor, intenta nuevamente.',
    TABLE_STATE_ERROR_RETRY: 'Reintentar',
    TABLE_STATE_EMPTY_SEARCH_TITLE: 'No se encontraron resultados',
    TABLE_STATE_EMPTY_SEARCH_SUBTITLE:
      'No se encontraron registros que coincidan con "{{query}}".',
    TABLE_STATE_EMPTY_NO_DATA_TITLE: 'No hay datos disponibles',
    TABLE_STATE_EMPTY_NO_DATA_SUBTITLE: 'No hay datos disponibles',
    TABLE_STATE_EMPTY_NO_DATA_CTA: 'Crear registro',

    // Day records dialog
    RECORDS_DIALOG_TITLE: 'Registros del día',
    RECORDS_DIALOG_CLOSE: 'Cerrar',
    RECORDS_DIALOG_VIEW_ALL: 'Ver todos los registros',
    RECORDS_COL_TIME: 'Hora',
    RECORDS_COL_EVENT: 'Evento',
    RECORDS_COL_STATUS: 'Estado',
    RECORDS_COL_LOCATION: 'Lugar',
    RECORDS_COL_CLOCK_TYPE: 'Tipo de marca',
    RECORDS_ESTIMATED: 'Estimada: {{time}}',
    RECORDS_EVENT_ENTRY: 'Entrada',
    RECORDS_EVENT_BREAK_START: 'Inicio de descanso',
    RECORDS_EVENT_BREAK_END: 'Fin de descanso',
    RECORDS_EVENT_EXIT: 'Salida',
    RECORDS_STATUS_ON_TIME: 'A tiempo',
    RECORDS_STATUS_ACCEPTABLE: 'Aceptable',
    RECORDS_STATUS_LATE_OR_ABSENT: 'Retardo o falta',
    RECORDS_CLOCK_WEB: 'Web',
    RECORDS_CLOCK_QR_TABLET: 'QR Tablet',
    RECORDS_CLOCK_APP_MOBILE: 'App Móvil',
    RECORDS_CLOCK_BIOMETRIC: 'Biométrico',

    EMPLOYEE_DIALOG_DETAIL_RECORDS_EDIT_RECORD: 'Editar registro',
  },
};
